<template lang="pug">
  .alert.cursor-pointer(
    v-if="serverError500"
    @click="closeAlert")
    | SERVER ERROR!
</template>

<script>
export default {
  computed: {
    serverError500 () {
      return this.$store.getters['app/serverError500']
    }
  },

  updated () {
    setTimeout(this.closeAlert, 3000)
  },

  methods: {
    closeAlert () {
      this.$store.dispatch('app/setServerErrorStatus', false)
    }
  }
}
</script>

<style scoped>
.alert {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 4rem;
  z-index: 1000;
  color: white;
  background-color: red;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
